import { createValidationSchema, validate } from "@";

export const schema = createValidationSchema({
  fromDate: validate("date"),
  toDate: validate("date"),
});

export const defaultValues = {
  fromDate: new Date(new Date().setHours(0, 0, 0, 0)),
  toDate: new Date(new Date().setHours(23, 59, 59, 999)),
};
